export default function ArticleFooter() {
  return (
    <footer className="bg-foreground-950 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <a href="https://twitter.com" target="_blank" rel="noopener nofollow" className="text-white/40 hover:text-white transition-colors text-sm underline cursor-pointer">
            Twitter
          </a>
          <a href="https://facebook.com" target="_blank" rel="noopener nofollow" className="text-white/40 hover:text-white transition-colors text-sm underline cursor-pointer">
            Facebook
          </a>
          <a href="https://instagram.com" target="_blank" rel="noopener nofollow" className="text-white/40 hover:text-white transition-colors text-sm underline cursor-pointer">
            Instagram
          </a>
          <p className="text-white/30 text-sm">© 2026 Kakobuy Finds Wiki. Wszelkie prawa zastrzeżone.</p>
          <a href="#" className="text-white/30 hover:text-white/60 transition-colors text-sm underline cursor-pointer">
            Polityka prywatności
          </a>
          <a href="#" className="text-white/30 hover:text-white/60 transition-colors text-sm underline cursor-pointer">
            Regulamin
          </a>
        </div>
      </div>
    </footer>
  );
}